import React from 'react';
import {connect} from "react-redux";
import {AppState} from "@Redux/store";
import {Dispatch} from "@Redux/type";

const AddAddParticipant: React.FC<AddAddParticipantProps> = ({}) => {
  return <div className="builder-edit-app row justify-content-center">
  </div>;
};

const mapStateToProps = (state: AppState) => ({})

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AddAddParticipant);

type AddAddParticipantProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>